import { render } from "./NonActionableNBALink.vue?vue&type=template&id=1acf446c&scoped=true"
import script from "./NonActionableNBALink.vue?vue&type=script&lang=js"
export * from "./NonActionableNBALink.vue?vue&type=script&lang=js"

import "./NonActionableNBALink.vue?vue&type=style&index=0&id=1acf446c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acf446c"]])

export default __exports__